<script setup lang="ts">
defineProps({
  /*
      Omits padding
      values: true, false
    */
  omitPadding: {
    type: Boolean,
    default: false,
  },

  /*
      Omits padding-top
      values: true, false
    */
  omitPaddingTop: {
    type: Boolean,
    default: false,
  },

  /*
      Omits padding-bottom
      values: true, false
    */
  omitPaddingBottom: {
    type: Boolean,
    default: false,
  },

  /*
      Omits padding-left
      values: true, false
    */
  omitPaddingLeft: {
    type: Boolean,
    default: false,
  },

  /*
      Omits padding-right
      values: true, false
    */
  omitPaddingRight: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="[
      $style.container,
      $style[omitPadding ? 'omitPadding' : ''],
      $style[omitPaddingTop ? 'omitPaddingTop' : ''],
      $style[omitPaddingBottom ? 'omitPaddingBottom' : ''],
      $style[omitPaddingLeft ? 'omitPaddingLeft' : ''],
      $style[omitPaddingRight ? 'omitPaddingRight' : ''],
    ]"
  >
    <slot name="container" />
  </div>
</template>

<style module>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1rem;
}

.omitPadding {
  padding: unset;
}

.omitPaddingTop {
  padding-top: 0;
}

.omitPaddingBottom {
  padding-bottom: 0;
}

.omitPaddingLeft {
  padding-left: 0;
}

.omitPaddingRight {
  padding-right: 0;
}
</style>
